import React, { useMemo, useState } from 'react';
import { Image } from 'react-native';
import { getDefaultProfilePhoto, getUserPhotoSource, isValidPhotoURL } from '../../utils/userPhoto';

export function AdminUserAvatar({ user, size = 44, style }) {
  const [loadFailed, setLoadFailed] = useState(false);
  const userKey = user?.id || user?.uid || user?.email;
  const defaultPhoto = useMemo(() => getDefaultProfilePhoto(userKey), [userKey]);
  const hasRemotePhoto = isValidPhotoURL(user?.photoURL) && !loadFailed;

  return (
    <Image
      source={hasRemotePhoto ? getUserPhotoSource(user) : defaultPhoto}
      onError={() => setLoadFailed(true)}
      style={[
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: 'rgba(0,0,0,0.06)',
        },
        style,
      ]}
    />
  );
}
